import React from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

interface StyleClipPromoModalProps {
  isOpen: boolean
  onClose: () => void
}

export const StyleClipPromoModal: React.FC<StyleClipPromoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate()
  
  if (!isOpen) return null

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleConfirm = () => {
    // 갤러리로 이동하면서 style-clip 탭 활성화
    navigate('/ai-studio/gallery?tab=style-clip')
    onClose()
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div
        className={classNames(
          'bg-white rounded-[40px] shadow-[0px_4px_20px_0px_rgba(0,0,0,0.25)] overflow-hidden',
          {
            'w-[335px] mx-4': true, // 모바일/데스크톱 공통 335px 폭
          }
        )}
      >
        {/* 상단 메시지 영역 */}
        <div className="flex flex-col justify-center items-center px-5 py-8 gap-6">
          {/* 제목 */}
          <div className="text-center">
            <p className="text-[18px] font-bold text-[#222222] leading-[1.44] text-center">
              🎉 당첨!
              <br />
              스타일 클립 무료 체험 서비스
            </p>
          </div>

          {/* 설명 */}
          <div className="w-full">
            <p className="text-[14px] font-bold text-main leading-[1.57] text-center">
              생성된 스타일 샷으로
              <br />
              숏폼 비율의 스타일 클립을 생성해드릴테니
              <br />
              무료로 경험해보세요!
            </p>
          </div>
        </div>

        {/* 하단 확인 버튼 */}
        <div className="flex">
          <button
            onClick={handleConfirm}
            className="w-full bg-[#00B7B9] text-white text-[14px] font-bold py-[19px] px-[10px] rounded-none rounded-br-[40px] hover:bg-[#009999] transition-colors"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  )
}
